import createAddMapping from './createAddMapping';
import createRemoveMappings from './createRemoveMappings';
import createGetAffected from './createGetAffected';
import createGetComponentAffected from './createGetComponentAffected';
import createAddResolvedPropertyMapping from './createAddResolvedPropertyMapping';
import createAddSelectablePropertyMapping from './createAddSelectablePropertyMapping';
import resolvedMappingHasKey from './resolvedMappingHasKey';
import getResolvedPropertyValue from './getResolvedPropertyValue';
import createRemoveResolvedPropertyMapping from './createRemoveResolvedPropertyMapping';
import createAddResolvedPropertyMappingWithKey from './createAddResolvedPropertyMappingWithKey';

const mappings = {};
const resolvedPropertyMappings = new Map();

export const addMapping = createAddMapping(mappings);
export const removeMappings = createRemoveMappings(mappings);
export const getAffected = createGetAffected(mappings);
export const getComponentAffected = createGetComponentAffected(mappings);
export const addResolvedPropertyMapping =
	createAddResolvedPropertyMapping(resolvedPropertyMappings);
export const removeResolvedMapping = createRemoveResolvedPropertyMapping(
	resolvedPropertyMappings,
	mappings
);
export const addResolvedPropertyMappingWithKey =
	createAddResolvedPropertyMappingWithKey(resolvedPropertyMappings);
export const addSelectableResolvedPropertyMapping =
	createAddSelectablePropertyMapping(resolvedPropertyMappings);
export const resolveMappingHasKey = resolvedMappingHasKey(resolvedPropertyMappings);
export const getResolvedProperty = getResolvedPropertyValue(resolvedPropertyMappings);
export {default as resolveSelectedProperty} from './resolveSelectedProperty';
export {default as resolveSelectedProperties} from './resolveSelectedProperties';
export {default as getSelectorParts} from './getSelectorParts';
export {default as isSelectableProperty} from './isSelectableProperty';
export {default as isSelector} from './isSelector';
export {default as updatePropertiesWithSelector} from './updatePropertiesWithSelector';
export {default as getPartsForNestedSelectableProps} from './getPartsForNestedSelectableProps';
export {default as applyUpdatesForSelectableProps} from './applyUpdatesForSelectableProps';

// Unstable APIs
export {default as createUnstableResolvePropertySelectorValue} from './createUnstableResolvePropertySelectorValue';
export {default as unstableAddRenderOnPropertySelectorValueChange} from './unstableAddRenderOnPropertySelectorValueChange';
export {default as unstableRemoveRenderOnPropertySelectorValueChange} from './unstableRemoveRenderOnPropertySelectorValueChange';
